import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { ClassificacaoPopulaModalComponent } from './popula';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClassificacaoPopulaModalComponent
    ],
    exports: [
        ClassificacaoPopulaModalComponent
    ]
})
export class ClassificacaoSharedModule { }
